import { ReactElement, useMemo } from 'react'
import { projectFilesRootGuid } from '@constants'
import { getElementDocuments } from '@domainUtils'
import { Download } from '@mui/icons-material'
import { IconButton, Stack } from '@mui/material'
import {
  GridRenderCellParams,
  DataGridPremium,
  GridRowSelectionModel,
} from '@mui/x-data-grid-premium'
import { useProjectFiles } from '@editorHooks'
import DeleteButton from '../UploadForm/components/DeleteButton'

interface Props {
  itemGuid?: string
  resetSelection?: () => void
  rowSelection?: GridRowSelectionModel
  setSelection?: (selection: GridRowSelectionModel) => void
}

const FileList = ({
  resetSelection,
  rowSelection,
  setSelection,
  itemGuid,
}: Props): ReactElement => {
  const { data } = useProjectFiles(projectFilesRootGuid)

  const filteredData = useMemo(() => {
    if (itemGuid) {
      return getElementDocuments(data.files, itemGuid)
    }
    return data.files
  }, [data, itemGuid])

  return (
    <>
      <DataGridPremium
        columns={[
          { field: 'name', headerName: 'Name', width: 250 },
          {
            field: 'actions',
            headerName: 'Aktionen',
            renderCell: (params: GridRenderCellParams<FileItem>) => (
              <Stack direction="row">
                <IconButton
                  size="small"
                  onClick={(e: { stopPropagation: () => void }) => {
                    e.stopPropagation()
                    window.open(params.row.url as string, '_blank')
                  }}
                >
                  <Download fontSize="inherit" />
                </IconButton>

                <DeleteButton
                  docGuid={params.row.guid}
                  docName={params.row.name}
                  rootGuid={projectFilesRootGuid}
                  onDelete={resetSelection}
                />
              </Stack>
            ),
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            display: 'flex',
            flex: 1,
          },
        ]}
        rows={filteredData || []}
        getRowId={row => row.guid}
        onRowSelectionModelChange={setSelection}
        rowSelectionModel={rowSelection}
        disableColumnSorting
        disableColumnFilter
        disableRowGrouping
        disableAggregation
        density="compact"
        hideFooter
        rowReordering={false}
      />
    </>
  )
}

export default FileList
